export const sanitizeEmail = (email: string) => {
  return email.replaceAll(' ', '')
}
